interface FilterGroupProps {
  label: string;
  options: { label: string; value: string }[];
  selected: string;
  onSelect: (value: string) => void;
}

export default function FilterGroup({
  label,
  options,
  selected,
  onSelect,
}: FilterGroupProps) {
  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-3 last:border-b-0 sm:flex-row sm:items-start sm:gap-4">
      <span className="shrink-0 pt-1 text-sm font-medium text-foreground-500 sm:w-14">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onSelect(option.value)}
            className={`rounded-md px-3 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap ${
              selected === option.value
                ? "bg-primary-500 text-background-50"
                : "text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}